import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BrowserFeedbackPageRoutingModule } from './browser-feedback-routing.module';

import { BrowserFeedbackPage } from './browser-feedback.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, BrowserFeedbackPageRoutingModule],
  declarations: [BrowserFeedbackPage]
})
export class BrowserFeedbackPageModule {}
